import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RichTextEditor } from '../../../../RichTextEditor';
import { isReadonly, StringField } from '../../Types';

interface Props {
  field: StringField;
  onChange: (value: string) => void;
}

const errorClassName = (field: StringField): string =>
  field.errors.length > 0 ? 'border-2 border-red-300 border-solid block rounded-md' : '';

const isDisabled = (field: StringField): boolean => isReadonly(field);

const MultiLine: React.FC<Props> = ({ field, onChange }) => (
  <span
    className={clsx(errorClassName(field), 'no-tailwindcss-base block list-outside')}
    data-intercom-target={`${field.name.replace(/_/g, '-')} text-editor`}
  >
    <RichTextEditor
      value={field.value}
      onChange={onChange}
      placeholder={field.placeholder.getOrElseValue('')}
      readonly={isDisabled(field)}
    />
  </span>
);

export default observer(MultiLine);
